import SingleNewsArticle from '@organisms/SingleNewsArticle';
import HeroCarousel from '@organisms/HeroCarousel';
import HeroAthletesCarousel from '@organisms/HeroAthletesCarousel';
import SocialMediaLinks from '@organisms/SocialMediaLinks';
import NextEvent from '@organisms/NextEvent';
import StatsPanel from '@organisms/StatsPanel';
import LifestyleGrid from '@organisms/LifestyleGrid';
import TextBlock from '@organisms/TextBlock';
import SinglePageFeature from '@organisms/SinglePageFeature';
import FeaturedAthletes from '@organisms/FeaturedAthletes';
import NewsCarousel from '@organisms/NewsCarousel';
import PastEventResult from '@organisms/PastEventResult';
import LatestNews from '@organisms/LatestNews';
import LatestNewsPanel from '@organisms/LatestNewsPanel';
import UsefulLinks from '@organisms/UsefulLinks';
import LifestylePanel from '@organisms/LifestylePanel';
import PromotionalBanner from '@organisms/PromotionalBanner';
import NewsArticleRow from '@organisms/NewsArticleRow';
import NewsletterSignup from '@organisms/NewsletterSignup';
import BannerImage from '@organisms/BannerImage';
import VideoCarousel from '@organisms/VideoCarousel';
import VideoDisplayPanel from '@organisms/VideoDisplayPanel';
import TimeTable from '@organisms/TimeTable';
import LiveBlog from '@organisms/LiveBlog';
import EventLiveBlog from '@components/organisms/LiveBlog/EventLiveBlog';
import LatestNewsPanelArticles from '@organisms/LatestNewsPanelArticles';
import LargeImageGallery from '@organisms/LargeImageGallery';
import Grid3x2 from '@organisms/Grid3x2';
import FullWidthTextBlock from '@organisms/FullWidthTextBlock';
import InteractiveMapModal from '@organisms/InteractiveMap';
import PreviewImages from '@assets/images/previews';
import LibraryPanel from '@organisms/LibraryPanel';
import FlashInterviewsModule from '@components/organisms/FlashInterviewsModule';
import ScrollNewsPanel from '@components/organisms/ScrollNewsPanel';
import VideoModule from '@components/organisms/VideoLibrary';
import VideoHero from '@components/organisms/VideoHero';

export const LIVE_BLOG = 'liveBlog';
export const FLASH_INTERVIEWS = 'flashInterviews';
export const EVENT_LIVE_BLOG = 'eventLiveBlog';
export const NEWS_ARTICLE_ROW = 'newsArticleRow';
export const LATEST_NEWS_PANEL_ARTICLES = 'LatestNewsPanelArticles';
export const BANNER_IMAGE = 'bannerImage';
// TODO: in content module itself those are hardcoded. Resolve dependancy cycle issue and reuse
export const TOP_RANKINGS = 'topRankings';
export const WORLD_RECORDS = 'worldRecords';
export const WORLD_LEADING_ATHLETES = 'worldLeadingAthletes';
export const STATS_PANEL = [TOP_RANKINGS, WORLD_RECORDS, WORLD_LEADING_ATHLETES];
export const INTERACTIVE_MAP = 'interactiveMap';
export const LIBRARY = 'MediaFileAssets';
export const SCROLL_NEWS_PANEL = 'scrollNewsPanel';
export const VIDEO_LIBRARY = 'insideTrackVideo';
export const VIDEO_HERO = 'heroVideo';

const CONTENT_MODULES = [
  {
    label: 'Inside Track Video Module',
    type: VIDEO_LIBRARY,
    modal: VideoModule,
    listItem: VideoModule.Item,
  },
  {
    label: 'Hero Video',
    type: VIDEO_HERO,
    modal: VideoHero,
    listItem: VideoHero.Item,
  },
  {
    label: 'Scroll News Panel',
    type: SCROLL_NEWS_PANEL,
    modal: ScrollNewsPanel,
    listItem: ScrollNewsPanel.Item,
  },
  {
    label: 'Featured Athletes',
    type: 'featuredAthletes',
    modal: FeaturedAthletes,
    previewImg: PreviewImages.featuredAthletes,
    listItem: FeaturedAthletes.Item,
  },
  {
    label: 'Hero Carousel',
    type: 'heroCarousel',
    modal: HeroCarousel,
    previewImg: PreviewImages.heroCarousel,
    listItem: HeroCarousel.Item,
  },
  {
    label: 'Hero Athletes Carousel',
    type: 'heroAthletesCarousel',
    modal: HeroAthletesCarousel,
    previewImg: PreviewImages.heroCarousel,
    listItem: HeroAthletesCarousel.Item,
  },
  {
    label: 'Grid 3x2',
    type: 'grid3x2',
    modal: Grid3x2,
    listItem: Grid3x2.Item,
  },
  {
    label: 'Large Image Gallery',
    type: 'largeImageGallery',
    modal: LargeImageGallery,
    listItem: LargeImageGallery.Item,
  },
  {
    label: 'Latest News Carousel',
    type: 'latestNewsCarousel',
    modal: LatestNews,
    previewImg: PreviewImages.latestNews,
    listItem: LatestNews.Item,
  },
  {
    label: 'Latest News Panel',
    type: 'latestNewsPanel',
    modal: LatestNewsPanel,
    previewImg: PreviewImages.latestNewsPanel,
    listItem: LatestNewsPanel.Item,
  },
  {
    label: 'Latest News Panel',
    type: LATEST_NEWS_PANEL_ARTICLES,
    modal: LatestNewsPanelArticles,
    previewImg: PreviewImages.latestNewsPanel,
    listItem: LatestNewsPanelArticles.Item,
  },
  {
    label: 'Library',
    type: LIBRARY,
    modal: LibraryPanel,
    listItem: LibraryPanel.Item,
    previewImg: PreviewImages.LibraryPanel,
  },
  {
    label: 'Lifestyle Grid',
    type: 'lifestyleGrid',
    modal: LifestyleGrid,
    previewImg: PreviewImages.lifestyleGrid,
    listItem: LifestyleGrid.Item,
  },
  {
    label: 'Live Blog',
    type: LIVE_BLOG,
    modal: LiveBlog,
    previewImg: PreviewImages.liveBlog,
    listItem: LiveBlog.Item,
  },
  {
    listItem: FlashInterviewsModule.Item,
    modal: FlashInterviewsModule,
    label: 'Flash Interviews',
    type: FLASH_INTERVIEWS,
  },
  {
    label: 'Event Live Blog',
    type: EVENT_LIVE_BLOG,
    modal: EventLiveBlog,
    previewImg: PreviewImages.liveBlog,
    listItem: EventLiveBlog.Item,
  },
  {
    label: 'Lifestyle Panel',
    type: 'lifestylePanel',
    modal: LifestylePanel,
    previewImg: PreviewImages.lifestylePanel,
    listItem: LifestylePanel.Item,
  },
  {
    label: 'News Carousel',
    type: 'newsCarousel',
    modal: NewsCarousel,
    previewImg: PreviewImages.newsCarousel,
    listItem: NewsCarousel.Item,
  },
  {
    label: 'Past Event Results',
    type: 'pastEventResults',
    modal: PastEventResult,
    previewImg: PreviewImages.pastEventResult,
    listItem: PastEventResult.Item,
  },
  {
    label: 'Newsletter Sign up',
    type: 'newsletterSignup',
    modal: NewsletterSignup,
    previewImg: PreviewImages.newsletterSignup,
    listItem: NewsletterSignup.Item,
  },
  {
    label: 'Next Event',
    type: 'nextEventBlock',
    modal: NextEvent,
    previewImg: PreviewImages.nextEvent,
    listItem: NextEvent.Item,
  },
  {
    label: 'Promotional Banner',
    type: 'promotionalBanner',
    modal: PromotionalBanner,
    previewImg: PreviewImages.promotionalBanner,
    listItem: PromotionalBanner.Item,
  },
  {
    label: 'Single News Article',
    type: 'singleNewsArticle',
    modal: SingleNewsArticle,
    previewImg: PreviewImages.singleNewsArticle,
    listItem: SingleNewsArticle.Item,
  },
  {
    label: 'Single Page Feature',
    type: 'singlePageFeature',
    modal: SinglePageFeature,
    previewImg: PreviewImages.singlePageFeature,
    listItem: SinglePageFeature.Item,
  },
  {
    label: 'Social Media Links',
    type: 'socialMediaLinks',
    modal: SocialMediaLinks,
    previewImg: PreviewImages.socialMediaLinks,
    listItem: SocialMediaLinks.Item,
  },
  {
    label: 'Text Block',
    type: 'textBlock',
    modal: TextBlock,
    previewImg: PreviewImages.textBlock,
    listItem: TextBlock.Item,
  },
  {
    label: 'Timetable',
    type: 'timeTable',
    modal: TimeTable,
    previewImg: PreviewImages.timeTable,
    listItem: TimeTable.Item,
  },
  {
    label: 'Video Carousel',
    type: 'videoCarousel',
    modal: VideoCarousel,
    previewImg: PreviewImages.videCarousel,
    listItem: VideoCarousel.Item,
  },
  {
    label: 'Inside Track Tokyo 2020',
    type: 'goggleBox',
    modal: VideoDisplayPanel,
    previewImg: PreviewImages.videCarousel,
    listItem: VideoDisplayPanel.Item,
  },
  {
    label: 'Useful Links',
    type: 'usefulLinks',
    modal: UsefulLinks,
    previewImg: PreviewImages.usefulLinks,
    listItem: UsefulLinks.Item,
  },
  {
    label: 'News Article Row',
    type: NEWS_ARTICLE_ROW,
    modal: NewsArticleRow,
    previewImg: PreviewImages.newsArticleRow,
    listItem: NewsArticleRow.Item,
  },
  {
    label: 'Promotional Banner',
    type: BANNER_IMAGE,
    modal: BannerImage,
    previewImg: PreviewImages.emailPromotionalBanner,
    listItem: BannerImage.Item,
  },
  {
    label: 'Add Stats',
    type: [STATS_PANEL[0], STATS_PANEL[1], STATS_PANEL[2]],
    modal: StatsPanel,
    previewImg: PreviewImages.statsPanel,
    listItem: StatsPanel.Item,
  },
  {
    label: 'Full Width Text Block',
    type: 'fullWidthTextBlock',
    modal: FullWidthTextBlock,
    previewImg: PreviewImages.textBlock,
    listItem: FullWidthTextBlock.Item,
  },
  {
    label: 'Interactive map',
    type: INTERACTIVE_MAP,
    modal: InteractiveMapModal,
    previewImg: PreviewImages.singlePageFeature,
    listItem: InteractiveMapModal.Item,
  },
];

export default CONTENT_MODULES;

export const presets = {
  pages: {
    omit: [NEWS_ARTICLE_ROW, BANNER_IMAGE, LATEST_NEWS_PANEL_ARTICLES],
  },
  articles: {
    pick: [LIVE_BLOG, LATEST_NEWS_PANEL_ARTICLES, INTERACTIVE_MAP, VIDEO_LIBRARY],
  },
  emails: {
    pick: [NEWS_ARTICLE_ROW, BANNER_IMAGE],
  },
};
